import { gql } from '@apollo/client';

export const STOP_PAUSABLE_TARIFF = gql`
  mutation stopPausableTariff($id: Int!) {
    stopClientSession(id: $id, ignorePause: true) {
      id
    }
  }
`;
